// Grouped client for Core operations
import { ApiConfiguration } from '../ApiConfiguration';

/**
 * HTTP client for Core operations
 *
 * Client for Core operations
 */
export class CoreClient {
  private readonly config: ApiConfiguration;

  constructor(config: ApiConfiguration) {
    this.config = config;
  }

  /**
   * Add Object to the list of recents for the user
   * AddObjectToRecents
   * @param options Optional request options (additional headers, etc.)
   */
  async addToRecents(id: string, objectType: string, options?: { headers?: Record<string, string> }): Promise<void> {
    let path = '/app/api/Object/{objectType}({id})/Recent'
      .replace('{id}', encodeURIComponent(String(id)))
      .replace('{objectType}', encodeURIComponent(String(objectType)))
      ;

    const url = `${this.config.baseUrl}${path}`;

    const requestInit: RequestInit = {
      method: 'POST',
      headers: {
        ...this.config.headers,
        ...options?.headers,
      },
    };

    const response = await this.config.executeRequest(url, requestInit);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

  }

}
